// utilities/errorHandler/patterns.ts — checks.ts split (error pattern lists)

export const RETRYABLE_MESSAGES = [
  "ECONNRESET", "ETIMEDOUT", "ENOTFOUND", "ECONNREFUSED",
  "network error", "failed to fetch",
];

export const CHUNK_PATTERNS = [
  "dynamically imported module",
  "loading chunk",
  "chunk load error",
  "script error for",
];

export const NETWORK_PATTERNS = [
  "failed to fetch",
  "network error",
  "fetch failed",
  "ECONNRESET",
  "ENETUNREACH",
  "ECONNREFUSED",
];

export const TIMEOUT_PATTERNS = ["timeout", "timed out", "ETEML"];

export const OFFLINE_PATTERNS = ["offline", "net::ERR_INTERNET_DISCONNECTED"];
